import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { DeleteOutlinedIcon, EditOutlinedIcon } from 'tuui';
import { DASHBOARD_RANGE_PICKER_PRESETS as PRESETS } from 'taboola-ultimate-ui';
import { FORM_MODES } from 'config/formModes';
import { useNavigate } from 'hooks';
import { DYNAMIC_REPORT_MODE } from 'modules/scheduled-reports/hooks/dynamicReportModeParam';
import { useDeleteDynamicReport } from 'modules/scheduled-reports/hooks/useDeleteDynamicReport';
import { mergeQueryParams } from 'modules/taboola-common-frontend-modules/query-params';
import { urlDateParser } from 'modules/taboola-common-frontend-modules/utils/urlUtils';
import { DATE_PRESET, END_DATE, REPORT_ID, START_DATE, useDateRange } from '../../hooks';
import ActionsCellRenderer from './ActionsCellRenderer';

export const DynamicReportsActionsCellRenderer = ({ data, ...rest }) => {
    const [, setDateRange] = useDateRange();
    const deleteReport = useDeleteDynamicReport();
    const navigate = useNavigate();
    const location = useLocation();
    const buttonConfigs = useMemo(
        () => [
            {
                onClick: () => {
                    setDateRange({
                        [START_DATE]: data.startDate && urlDateParser(data.startDate),
                        [END_DATE]: data.endDate && urlDateParser(data.endDate),
                        [DATE_PRESET]: PRESETS.CUSTOM === data.dateRange ? null : data.dateRange,
                    });
                    navigate(
                        `${location.pathname}${mergeQueryParams('', {
                            [REPORT_ID]: data.id,
                            [DYNAMIC_REPORT_MODE]: FORM_MODES.EDIT,
                        })}`
                    );
                },
                icon: <EditOutlinedIcon />,
                iconLabel: 'edit',
                dataMetricComponent: 'EditActionButton',
            },
            {
                onClick: () => deleteReport(`${data.id}`, `${data.name}`),
                icon: <DeleteOutlinedIcon />,
                iconLabel: 'delete',
                dataMetricComponent: 'DeleteActionButton',
            },
        ],
        [location, navigate, data, deleteReport, setDateRange]
    );

    return <ActionsCellRenderer data={data} buttonConfigs={buttonConfigs} {...rest} />;
};
